module.exports = __webpack_public_path__ + "static/media/care_device_zoom_out.2098f2aa.svg";